module.exports = __webpack_public_path__ + "media/country_flags/lr-29ee59c4.png";